<template>
  <v-app id="inspire" light>
    <component :is="currentLayout">
      <router-view />
    </component>

    <notifications group="hasBottomNavigation" class="pl-notification-bottom-navigation" position="bottom right" />
    <notifications position="bottom right" />
  </v-app>
</template>

<script>
import QrScan from '@/pages/QrScan/QrScan'
import Preloader from '@/components/Preloader/Preloader'
import MainLayout from '@/layouts/Main/Main'
import { mapGetters } from 'vuex'
import store from '@/store/index'

export default {
  name: 'App',
  components: {
    QrScan,
    preloader: Preloader,
  },
  watch: {
    $route(newVal, oldVal) {
      if (newVal.query.selected_date !== oldVal.query.selected_date) store.commit('setSelectedDate')
    },
  },
  computed: {
    ...mapGetters(['showPreloader', 'load']),
    currentLayout() {
      return this.$route.meta.layout ?? MainLayout
    },
  },
  currentLayout() {
    return this.$route.meta.layout ?? MainLayout
  },
}
</script>
